import React, { Component } from 'react';
import CloudinaryImage from './CloudinaryImage';

export default class PredefinedImage extends Component {
  static DPR = window.devicePixelRatio || 2;
  
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    this.props.onSelect(this.props.resourceInfo);
    e.preventDefault();
  }

  render() {
    return(
      <li>
        <a onClick={this.handleClick} href="#">
          <CloudinaryImage transformation={{aspect_ratio: '200:131', width: 'auto', crop: 'fill', gravity: 'faces', dpr: 'auto'}} format="jpg" publicId={this.props.resourceInfo.public_id} />
        </a>
      </li>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/components/PredefinedImage.js
 **/